var render = function render(){var _vm=this,_c=_vm._self._c;return _c('MediaWatcher',{ref:"mediaWatcherPhoto",attrs:{"items":_vm.photos,"type":"photo","fullscreen":true}})
}
var staticRenderFns = []

export { render, staticRenderFns }